import { render, staticRenderFns } from "./GCompetencyComparison.vue?vue&type=template&id=711ad0c0&scoped=true&"
import script from "./GCompetencyComparison.vue?vue&type=script&lang=ts&"
export * from "./GCompetencyComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ad0c0",
  null
  
)

export default component.exports